import React, { useState, useEffect } from "react";
import { Box, Card, Divider, Typography } from '@curves/ui-base';

import ReadSectionCard from "@Local/CyclePurchase/Detail/Main/Components/ReadSectionCard";
import { Tablenization } from "@Local/Components";
import { parseDate } from "@Util/moment.util";
import useCyclePurchaseOverviewApi from "@Apis/useCyclePurchaseOverviewApi";
const currency = n => (isFinite(n) ? n : 0).toLocaleString(undefined, { minimumFractionDigits: 0 });
const FutureOrderSectionByRead = props => {
	const { effectID, cycleOrderID, clubName } = props;
	const { getCyclePurchaseDetailEffectApi } = useCyclePurchaseOverviewApi();
	const [effectData, setEffectData] = useState(null);
	// 取得變更單詳細
	useEffect(() => {
		let isMounted = true;
		const fetchEffectData = async () => {
			if (!effectID || !cycleOrderID) return;
			const res = await getCyclePurchaseDetailEffectApi({
				cycleOrderID: cycleOrderID,
				effectID,
			});
			// 只有在組件仍然掛載時才更新狀態
			if (isMounted) {
				setEffectData(res && res.success !== false ? res.result || res : res);
			}
		};
		fetchEffectData();
		// 清理函數
		return () => {
			isMounted = false;
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [effectID, cycleOrderID]);
	// 訂購人資訊（未來）
	const futureConsumerItems =  [
			{ label: "所屬店鋪", xs: 4, value: clubName, placeholder: "無資料" },
			{ label: "會員姓名", xs: 4, value: effectData?.memberName, placeholder: "無資料" },
			{ label: "會員編號", xs: 4, value: effectData?.memberNo, placeholder: "無資料" },
			{ label: "手機/電話", xs: 4, value: effectData?.cellPhone, placeholder: "無資料" },
			{
				label: "生日",
				xs: 4,
				value: effectData?.birthday ? parseDate(effectData.birthday) : null,
				placeholder: "無資料",
			},
		];
	// 變更單資訊
	const futureOrderItems = [
			{ label: "變更單編號", xs: 4, value: effectData?.effectNo, placeholder: "無資料" },
			{
				label: "生效日期",
				xs: 4,
				value: effectData?.effectDate ? parseDate(effectData.effectDate) : null,
				placeholder: "無資料",
			},
			{
				label: "建單日期",
				xs: 4,
				value: effectData?.effectCreateDate ? parseDate(effectData.effectCreateDate) : null,
				placeholder: "無資料",
			},
			{ label: "變更單狀態", xs: 4, value: effectData?.effectStatusText, placeholder: "無資料" },
			{ label: "建單擔當", xs: 4, value: effectData?.employeeName, placeholder: "無資料" },
		];
	// 表頭
	const headerRow =  [
			{
				cellKey: "productName",
				headerLabel: "商品",
				formatCell: (_cell, row) => <Typography>{row?.productName ?? "無資料"}</Typography>,
			},
			{
				cellKey: "unitPrice",
				headerLabel: "單價",
				formatCell: (_cell, row) => <Typography>{isFinite(row?.salePrice) ? currency(row.salePrice) : "無資料"}</Typography>,
			},
			{
				cellKey: "quantity",
				headerLabel: "盒數",
				formatCell: (_cell, row) => <Typography>{row?.quantity ?? "無資料"}</Typography>,
			},
			{
				cellKey: "total",
				headerLabel: "總計",
				formatCell: (_cell, row) => {
					const total = (row?.salePrice ?? 0) * (row?.quantity ?? 0);
					return <Typography>{currency(total)}</Typography>;
				},
			},
		];
	const itemsData = effectData?.items ?? [];
	const grandTotal = currency(itemsData.reduce((sum, item) => sum + (Number(item?.salePrice) || 0) * (Number(item?.quantity) || 0), 0));
	return (
		<Card>
			{/* 訂購人資訊 */}
			<ReadSectionCard title="訂購人資訊" outlined={false} raised={false} headerBg="black" gridSpacing={3} items={futureConsumerItems} />
			{/* 變更單資訊 */}
			<ReadSectionCard title="變更單資訊" outlined={false} raised={false} headerBg="black" gridSpacing={3} items={futureOrderItems} />
			{/* 變動的項目 */}
			<Typography variant="h4" className="font-weight-900">
				變動的項目
			</Typography>
			<Card.CardHeader
				title={
					<Typography variant="body-1" className="font-weight-900">
						訂購商品
					</Typography>
				}
				className="bg-black"
			/>
			<Card.CardContent className="p-4">
				<Box className="scroll-arrow-container overview">
					<Tablenization cardProps={{ className: "underline-table" }} isPagination>
						<Tablenization.TableRowHeader headerRow={headerRow} color="font-color-5" cellWidth={null} />
						<Tablenization.TableRowBody
							headerRow={headerRow}
							rowsData={itemsData}
							children={null}
							rowOnClick={() => {}}
							bodyRowHeight={null}
							cellWidth={null}
							alertProps={{ text: "尚無資料" }}
						/>
					</Tablenization>
				</Box>
				<Divider />
				{/* 合計 */}
				<Box className="mt-3" style={{ textAlign: "right" }}>
					<Typography variant="h5" className="text-primary mb-1 font-weight-900">
						合計: $ {grandTotal}
					</Typography>
					<Typography variant="body2" className="text-muted">
						售價已包含 5% 加值營業稅及運費（僅配送台灣本島）
					</Typography>
				</Box>
			</Card.CardContent>
		</Card>
	);
};
export default FutureOrderSectionByRead;
